// ================================================================
// 💰 CURRENCY DISPLAY - Componente para exibir valores monetários
// ================================================================

import React from 'react';
import CurrencyFormatter from '../../utils/CurrencyFormatter';

/**
 * 💰 CurrencyDisplay - Exibe valores monetários formatados
 * 
 * @param {Object} props
 * @param {number} props.value - Valor em centavos
 * @returns {JSX.Element}
 */
const CurrencyDisplay = ({ value }) => {
  return <>{CurrencyFormatter.centsToFormatted(value)}</>;
};

export default CurrencyDisplay;

